import {Client} from "../model/interface/client.interface";
import {ApiService} from "./api.service";
import {AxiosResponse} from "axios";

export class ClientService {
    public static async loadUserFromAPI() {
        let url: string = ApiService.getInstance().getClientURL();

        const result: AxiosResponse<Client> | false = await ApiService.getInstance().getUnhandled(url);

        if(!result) {
            console.error("Could not retrieve User");
            return null;
        }
        return result.data;
    }

    public static async loadAllUsersMeta() {
        let url: string = ApiService.getInstance().getReadAllClientsMetaURL();

        const result: AxiosResponse<string[]> | false = await ApiService.getInstance().getUnhandled(url);

        if(!result) {
            console.error("Could not retrieve Clients!");
            return null;
        }
        return result.data;
    }
    public static async loadAllUsers() {
        let url: string = ApiService.getInstance().getReadAllClientsURL();

        const result: AxiosResponse<Client[]> | false = await ApiService.getInstance().getUnhandled(url);

        if(!result) {
            console.error("Could not retrieve Clients!");
            return null;
        }
        return result.data;
    }

    public static async deleteUser(name: string) {
        let url: string = ApiService.getInstance().getClientDeleteURL(name);

        const result: AxiosResponse<string> | false = await ApiService.getInstance().get(url);

        if(!result) {
            console.error("Could not delete User");
            return null;
        }
        return result.data;
    }

    public static async getRoles() {
        let url: string = ApiService.getInstance().getRolesURL();

        const result: AxiosResponse<string[]> | false = await ApiService.getInstance().get(url);

        if(!result) {
            return null;
        }
        return result.data;
    }
    public static async isAdmin() {
        let url: string = ApiService.getInstance().getIsAdminURL();

        const result: AxiosResponse<boolean> | false = await ApiService.getInstance().get(url);

        if(!result) {
            return null;
        }
        return result.data;
    }
}